var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"allFund"},[_c('div',{staticClass:"contentWrap1"},[_c('div',{staticClass:"topText"},[_vm._v("用户总资金结构图")]),_c('TreeChart',{attrs:{"tree-data":_vm.fundData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }